import { render, staticRenderFns } from "./PrintTrip.vue?vue&type=template&id=5cb06168&scoped=true&"
import script from "./PrintTrip.vue?vue&type=script&lang=js&"
export * from "./PrintTrip.vue?vue&type=script&lang=js&"
import style0 from "./PrintTrip.vue?vue&type=style&index=0&id=5cb06168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb06168",
  null
  
)

export default component.exports